
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { Dropdown } from 'primereact/dropdown';


export const ParameterDropdown = ({instrument, parameterName, label, width}) => {
    
    const parameterDescription = instrument.getParameterDescription(parameterName);
    const selector = parameterDescription.selector ?? instrument.getDisplayParameterSelector(parameterName);
    const currentValue = useSelector(selector);

    const dropdownOptions = useMemo(() => {
        if (parameterDescription.type === 'enum') {
            return parameterDescription.options.map(option => ({ label: parameterDescription.labelForOption?.[option] ?? option, value: option }));
        }
        return [];
    }, [parameterDescription]);

    const handleParameterChange = (e) => {
        const newValue = e.value;
        instrument.updateParametreInstrument(parameterName, newValue);
    };
    
    return (
        <div className="flex flex-col" style={{width: width || "100%"}}>
            {label!==null && <label htmlFor={parameterName}>{label || parameterDescription.label}</label>}
            <Dropdown id={parameterName}
                value={currentValue}  
                options={dropdownOptions}
                onChange={handleParameterChange}
                scrollHeight="200px"  
            />
        </div>
    );
}